import { apiService } from './ApiService';

export interface SessionFeedbackRequest {
  session_id: string;
  rating: number;
  comments?: string;
}

export interface MessageFeedbackRequest {
  session_id: string;
  message_id: string;
  rating: number;
  helpful: boolean;
  comments?: string;
}

export interface FeedbackResponse {
  status: string;
  message: string;
  feedback_id: number;
}

class FeedbackService {
  async rateSession(data: SessionFeedbackRequest): Promise<FeedbackResponse> {
    try {
      const response = await apiService.authenticatedFetch('/api/feedback/session', {
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Failed to submit session feedback: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting session feedback:', error);
      throw error;
    }
  }

  async rateMessage(data: MessageFeedbackRequest): Promise<FeedbackResponse> {
    try {
      const response = await apiService.authenticatedFetch('/api/feedback/message', {
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Failed to submit message feedback: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting message feedback:', error);
      throw error;
    }
  }
}

export default new FeedbackService();
